import { Textarea, TextareaProps } from '@veracity/vui'

import { BaseFormItem, BaseFormItemProps } from './BaseFormItem'

export type TextareaBaseFormProps = BaseFormItemProps & TextareaProps

export type TextareaFormControlProps = TextareaBaseFormProps

export const TextareaFormControl = ({
  control,
  formControlName,
  label,
  rules,
  ...props
}: TextareaFormControlProps) => (
  <BaseFormItem
    label={label}
    control={control}
    rules={rules}
    formControlName={formControlName}>
    <Textarea {...props} />
  </BaseFormItem>
)
